import type React from 'react';
import { useAvatarStore } from '@features/avatar-integration';
import {
  CameraIcon,
  UserIcon,
  SparklesIcon,
  ClosedCaptionIcon,
  LayoutIcon,
  ChevronUpIcon,
  ChevronDownIcon,
} from '@shared/ui';
import type { OverlayLayerKind } from '@shared/types';

const LAYER_ICONS: Record<OverlayLayerKind, React.ComponentType<{ className?: string }>> = {
  camera: CameraIcon,
  avatar: UserIcon,
  effects: SparklesIcon,
  captions: ClosedCaptionIcon,
  ui: LayoutIcon,
};

export function OverlayOrderList() {
  const overlayOrder = useAvatarStore((state) => state.integration.overlayOrder);
  const reorderOverlay = useAvatarStore((state) => state.reorderOverlay);
  const sorted = [...overlayOrder].sort((a, b) => a.order - b.order);

  return (
    <div className="flex gap-3">
      <ol className="flex-1 space-y-2">
        {sorted.map((layer) => {
          const Icon = LAYER_ICONS[layer.id];
          return (
            <li
              key={layer.id}
              className="flex items-center gap-3 rounded-lg border border-surface-border bg-surface-2 px-3 py-2.5"
            >
              <span className="w-4 text-sm text-text-muted">{layer.order}</span>
              <Icon className="h-4 w-4 text-text-secondary" />
              <span className="text-sm text-text-primary">{layer.label}</span>
            </li>
          );
        })}
      </ol>

      <div className="flex flex-col items-center justify-center gap-1 rounded-lg border border-surface-border bg-surface-2 px-3 py-4">
        <button
          type="button"
          aria-label="Move layer up"
          onClick={() => reorderOverlay(sorted[0]?.id, 'up')}
          className="rounded p-1 text-text-secondary hover:bg-surface-3 hover:text-text-primary"
        >
          <ChevronUpIcon className="h-4 w-4" />
        </button>
        <span className="my-1 whitespace-nowrap text-[11px] leading-tight text-text-muted">
          Move
          <br />
          Up / Down
        </span>
        <button
          type="button"
          aria-label="Move layer down"
          onClick={() => reorderOverlay(sorted[sorted.length - 1]?.id, 'down')}
          className="rounded p-1 text-text-secondary hover:bg-surface-3 hover:text-text-primary"
        >
          <ChevronDownIcon className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
